import { createMuiTheme } from '@material-ui/core/styles';
import {blue, yellow, red, orange, green} from '@material-ui/core/colors'

export default createMuiTheme({
    palette: {
      primary: { light: blue[300], main: blue[500], dark: blue[700] },
      secondary: { light: yellow[300], main: yellow[500], dark: yellow[700] },
      error: { light: red[300], main: red[500], dark: red[700] },
      type: 'light',
    }
});


// WEBPACK FOOTER //
// ./src/styles/Theme.js